import ShareMenuContainer from "./ShareMenu";

export default ShareMenuContainer;
